function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M16 8v2h-3v4.5a2.5 2.5 0 11-2-2.45V8h4V4H5v16h14V8zM3 2.992A1 1 0 014 2h12l5 5v13.993A1 1 0 0120.007 22H3.993A1 1 0 013 21.008z",
  transform: "translate(-3 -2)",
  fill: "#bebebe"
})));